module.exports = __webpack_public_path__ + "img/apple.aaa4cf57.svg";